import { ApiService } from '@b2b/common/services/api/types';
import { IInjectable, StateParams } from '@uirouter/angularjs';
import { ACMEResponse } from '@b2b/types/core';
import { SubscriptionDetail } from '@b2b/types/subscriptions';
import { IPromise } from 'angular';

export function SubscriptionDataResolver(): IInjectable {
  return [
    '$stateParams',
    'ApiService',
    function ($stateParams: StateParams, ApiService: ApiService): IPromise<{ data: ACMEResponse<SubscriptionDetail> } | { data: null }>{
      return ApiService.subscriptions.detail($stateParams.id).catch(() => {
        // We return null if the user doesn't have sub details so that portion is not painted
        return { data: null };
      });
    },
  ];
}
